import {
  DURATION_FILTER_VALUE_SEPARATOR,
  RANGE_FILTER_SEPARATOR,
} from '@aibees/elephant/constants/filters';
import { SearchBrowseParams } from '@aibees/elephant/types';
import { useMemo } from 'react';
import { LimitType, TimeType } from '../types';

export function useCurrentValue(
  params: Partial<SearchBrowseParams>,
  field: string
) {
  return useMemo(() => {
    const stringValue = params[field!];
    const tmp = stringValue
      ? stringValue.split(RANGE_FILTER_SEPARATOR)
      : ['', ''];
    const times: Set<TimeType> = new Set<TimeType>([
      TimeType.YEAR,
      TimeType.MONTH,
    ]);
    const limits: Set<LimitType> = new Set<LimitType>([
      LimitType.MIN,
      LimitType.MAX,
    ]);
    const values = [
      ['', ''],
      ['', ''],
    ];

    limits.forEach((l) => {
      times.forEach((t) => {
        const str = tmp[l];
        const v = str?.split(DURATION_FILTER_VALUE_SEPARATOR);
        if (v?.[t]) values[l][t] = v[t];
      });
    });

    return values;
  }, [field, params]);
}
